import { differenceInDays } from 'date-fns';
import { convertLocalDateToUTCDate } from '@izimi/utils';
import { _collection } from '../common';
const EXPIRATION_DAYS = 60;
class CommunicationDetailsEntity {
    id;
    title;
    message;
    creationDate;
    expirationDate;
    isSeen;
    sender;
    receiver;
    documents;
    [_collection];
    constructor(communicationDetails, collection) {
        Object.assign(this, communicationDetails);
        this[_collection] = collection;
    }
    calculateDays(date) {
        const now = convertLocalDateToUTCDate(new Date());
        const scheduledDate = convertLocalDateToUTCDate(new Date(date));
        const difference = differenceInDays(scheduledDate, now);
        return difference <= 0 ? 1 : difference;
    }
    get remainingDays() {
        return this.calculateDays(this.expirationDate);
    }
    get isExpiringSoon() {
        if (this.remainingDays == null)
            return false;
        return this.remainingDays < EXPIRATION_DAYS;
    }
    get hasImportantDocuments() {
        return this.documents.some(document => document.isImportant);
    }
    get hasAvailableDocuments() {
        return this.documents.some(document => document.isAvailable);
    }
    get availableDocumentIds() {
        if (!this.hasAvailableDocuments)
            return [];
        return this.documents.filter(document => document.isAvailable).map(document => document.documentId);
    }
    getAvailableDocumentCounts() {
        const { importantDocumentsCount, documentsCount } = this.documents.reduce((acc, { isImportant, isAvailable }) => {
            if (!isAvailable)
                return acc;
            if (isImportant) {
                acc.importantDocumentsCount++;
            }
            else {
                acc.documentsCount++;
            }
            return acc;
        }, { importantDocumentsCount: 0, documentsCount: 0 });
        return { importantDocumentsCount, documentsCount };
    }
}
export default CommunicationDetailsEntity;
